module.exports = __webpack_public_path__ + "static/media/20130613_403944_598294.73e35942.mp3";